import { SelectOptionType } from '@montel/montelpro-shared-components-v2';
import { getAdminRoleNameFromValue } from 'domain/account/enums';

export const toRoleOptions = (roles: string[]): SelectOptionType[] =>
	roles.map((role) => ({
		value: role,
		label: getAdminRoleNameFromValue(role),
	}));
